export const images = {
    loginLogo: {
        url: "https://storage.googleapis.com/hoc-site-data/images/1716566910_hoc-logo.png",
        name: "Login Image",
        alt: "dsjnaf"
    }
}